export default "__VITE_ASSET__3c6bd6e4__"